/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Crosspostingmaximages2Inputs */

const en_crosspostingmaximages2 = /** @type {(inputs: Crosspostingmaximages2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You can add up to ${i?.count} images.`)
};

const de_crosspostingmaximages2 = /** @type {(inputs: Crosspostingmaximages2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du kannst bis zu ${i?.count} Bilder hinzufügen.`)
};

/**
* | output |
* | --- |
* | "You can add up to {count} images." |
*
* @param {Crosspostingmaximages2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingmaximages2 = /** @type {((inputs: Crosspostingmaximages2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingmaximages2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingmaximages2(inputs)
	return de_crosspostingmaximages2(inputs)
});
export { crosspostingmaximages2 as "crosspostingMaxImages" }